import { render } from "./Events.vue?vue&type=template&id=0fc3d7b8&bindings={\"events\":\"data\",\"dataReady\":\"data\",\"errorMessage\":\"data\",\"eventsUnsub\":\"data\",\"activeEvents\":\"options\",\"userId\":\"options\",\"canShare\":\"options\",\"getEvents\":\"options\",\"share\":\"options\",\"getImgUrl\":\"options\"}"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"
script.render = render

export default script